module.exports = "<igo-share-map\r\n  igoShareMapBinding\r\n  [hasCopyLinkButton]=\"hasCopyLinkButton\"\r\n  [hasShareMapButton]=\"hasShareMapButton\"\r\n></igo-share-map>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/lib/tool/tools/share-map-tool/share-map-tool.component.html
// module id = 1159
// module chunks = 0